import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpMmtService } from 'src/app/services/http-mmt.service';
import { MmtCovidVisitDetail } from 'src/app/models/mmt.model';
import { ActivatedRoute } from '@angular/router';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-weedfree-form-mmt-covid',
  templateUrl: './weedfree-form-mmt-covid.component.html',
  styleUrls: ['./weedfree-form-mmt-covid.component.scss']
})
export class WeedfreeFormMmtCovidComponent implements OnInit {

  @ViewChild('f') form: NgForm;

  files: any[] = [];
  successMessage: string = '';
  uploadProgress: number = 0;
  visit: number;

  constructor(
    private http: HttpMmtService,
    private route: ActivatedRoute
    ) { }

  ngOnInit(): void {
    this.visit = this.route.snapshot.params['id'];
  }


  onFileChanged(event: any) {
    this.files = event.target.files;
  }

  onSubmit(form: NgForm) {
    // toDataURL == png format
    window.scroll(0, 0);
    this.successMessage = '';

    let visit: MmtCovidVisitDetail = {
      visit: this.visit,
      grabHandlesGates: form.value.grabHandlesGates ? true : false,
      cabSurfaces: form.value.cabSurfaces ? true : false,
      messRoomSurfaces: form.value.messRoomSurfaces ? true : false,
      toiletSurfaces: form.value.toiletSurfaces ? true : false,
      aislePanelsCabinets: form.value.aislePanelsCabinets ? true : false,
      handContactAreasThroughout: form.value.handContactAreasThroughout ? true : false,
      comments: form.value.comments
    };

    this.http.addCovidVisit(visit).subscribe((response: number) => {

      if (this.files.length > 0) {
        this.successMessage = 'Uploading photos...'
        this.http.uploadCovidFiles(this.visit, this.files).subscribe((response) => {

          if (response.status == 'progress') {
            this.uploadProgress = Number(response.message);
          } else if (response.status == 'complete') {
            this.successMessage = 'Visit successfully added and images uploaded!';
            this.uploadProgress = 0;
          }

        }, (error) => {
            console.log(error);
        })

      } else {
        this.successMessage = 'Visit successfully added!';
      }

    }, (error) => {
        console.log(error);
    });
  }
}
